<div class="avatar-container">
  <img
    class="img"
    src="assets/images/irec_agente.jpg"
    [alt]="otherUser()?.fullName || 'User avatar'"
    [class.loading]="!otherUser()"
  />
  <div class="online-indicator" [class.online]="isUserOnline()"></div>
</div>

<div class="details-preview">
  <div class="name-and-date">
    <h3 class="full-name" [class.loading]="!otherUser()">
      {{ otherUser()?.fullName || 'Loading...' }}
    </h3>
    <div class="time-container">
      <small class="date" [title]="formattedDate()">
        {{ relativeTime() }}
      </small>
    </div>
  </div>

  <div class="message-row">
    <div class="message-preview">
      <p [class.loading]="!otherUser()">{{ messagePreview() }}</p>
    </div>
  </div>
</div>
